import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.non-domain-protection-key', {
        url: '/non-domain-protection-key',
        component: 'companyManageApplicationIntegrationDevelopersNonDomainProtectionKey',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/non-domain-protection-key/non-domain-protection-key.state.js